.me-widget-loader {
  display: block;
}
